const moduleName = 'header';

module.exports = () => {

    Array.from(document.querySelectorAll('.js-header')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const header = self;
        const toggle = header.querySelector('.js-header-toggle');
        const closeBtn = header.querySelector('.js-header-close');
        let windowWidth = window.clientWidth;
        let documentScrollTop = window.scrollY || document.body.scrollTop;

        toggle.addEventListener('click', () => {
            if (header.classList.contains('_open')) {
                hideMenu();
            } else {
                showMenu();
            }
        });

        closeBtn.addEventListener('click', () => {
            if (header.classList.contains('_open')) {
                header.classList.remove('_open');
            }
        });

        window.addEventListener('resize', () => {
            if (header.classList.contains('_open') && windowWidth < 1024 && document.body.clientWidth >= 1024) {
                hideMenu();
            }

            windowWidth = document.body.clientWidth;
            toggleHeaderVisibility();
        });

        window.addEventListener('keydown', (event) => {
            if (event.keyCode === 27 && header.classList.contains('_open')) {
                hideMenu();
            }
        });

        toggleHeaderVisibility();
        window.addEventListener('scroll', toggleHeaderVisibility);



        function toggleHeaderVisibility() {
            if (header.classList.contains('_static')) return;

            let newDocumentScrollTop = window.scrollY || document.body.scrollTop;

            if (documentScrollTop < newDocumentScrollTop && newDocumentScrollTop > header.offsetHeight) {
                header.classList.add('_hidden');
                if (window.innerWidth > 1023) {
                    hideDropdown(navItem, dropItem, 100, 300)
                }
            } else {
                header.classList.remove('_hidden');
            }

            documentScrollTop = newDocumentScrollTop;
        }

        function showMenu() {
            header.classList.add('_open');
            overlay().show();
            $('html').addClass('fixed')
        }

        function hideMenu() {
            header.classList.remove('_open');
            header.classList.remove('_slide');
            overlay().hide();
            $('html').removeClass('fixed')
            hideDropdown(navItem, dropItem, 0, 0)
        }

        // dropdown logic

        const navItem = header.querySelectorAll('.js-nav-item');
        const dropItem = header.querySelectorAll('.js-dropdown-item');
        const backlink = header.querySelector('.js-header-backlink')
        let timeout = null

        if (!navItem || !dropItem || !backlink) return
        
        // desktop

        function hideDropdown (link, target, delay, duration) {
            clearTimeout(timeout)
            timeout = null
            timeout = setTimeout(() => {
                $(target).fadeOut(duration).removeClass('active')
                $(link).removeClass('active')
                overlay().hideSimple();
            }, delay)
        }

        function showDropdown (el, duration) {
            if (el.classList.contains('active')) {
                clearTimeout(timeout)
                timeout = null
                return;
            }
            const targetId = el.getAttribute('data-target-id')
            let targetEl = null

            timeout = setTimeout(() => {
                overlay().showSimple();
                dropItem.forEach(item => {
                    if (item.getAttribute('id') === targetId) {
                        targetEl = item
                    }
                })
                el.classList.add('active')
                $(targetEl).fadeIn(duration).addClass('active')
            }, 500)

        }


        navItem.forEach(el => {
            el.addEventListener('mouseenter', e => {
                if (window.innerWidth < 1024) return;
                showDropdown(el, 300)
            })
        })

        navItem.forEach(el => {
            el.addEventListener('mouseleave', e => {
                if (window.innerWidth < 1024) return;
                hideDropdown(navItem, dropItem, 100, 300)
            })
        })

        dropItem.forEach(el => {
            el.addEventListener('mouseenter', e => {
                if (window.innerWidth < 1024) return;
                clearTimeout(timeout)
                timeout = null
            })
        })

        dropItem.forEach(el => {
            el.addEventListener('mouseleave', e => {
                if (window.innerWidth < 1024) return;
                hideDropdown(navItem, dropItem, 300, 300)
            })
        })

        // mobile

        navItem.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault()
                if (window.innerWidth > 1023) return;
                showDropdown(el, 10)
                header.classList.add('_slide')
            })
        })

        backlink.addEventListener('click', e => {
            e.preventDefault()
            header.classList.remove('_slide')
        })
    });

};